<ng-container>
  <div mat-dialog-title>
      <div class="title">{{'restaurant.Edit Reservation Channels' | translate}}</div>
      <button mat-icon-button class="close" (click)="openConfirmDialog()">
          <mat-icon class="pop-close">close</mat-icon>
      </button>
  </div>
  <mat-dialog-content>

    <div *ngIf='dataLoading' class="dataLoading">
      <mat-spinner class="m-auto" diameter="50"></mat-spinner>
    </div>

    <div *ngIf="!dataLoading" class="mat-dialog-body channels">
      <!-- <form [formGroup]="formGroup"> -->
        <div class="fields-group">
          <div class="grey-list-items" *ngFor="let reservation of reservationChannels; index as index">
              <div class="list-item" *ngIf="reservation.isOnlineReservation && !reservation.isOther">
                  <div class="d-flex align-items-center">
                      <div class="title font-16"> {{reservation.name}}
                          <br>
                          <p class="font-12 mt-2">{{"restaurant.When this is set off, it means the restaurant temporarily pause reservations received through the BonTech Mobile App." | translate}}</p>
                      </div>
                  </div>
                  <div>
                      <mat-slide-toggle [(ngModel)]="reservation.isSelected" [ngModelOptions]="{standalone: true}"></mat-slide-toggle>
                  </div>
              </div>
          </div>

          <p class="info font-14">
            {{"restaurant.Channels via which the restaurant receive reservations to be scheduled." | translate}}
          </p>

          <div class="toggle-list" *ngFor="let reservation of reservationChannels; index as index">

            <ng-container *ngIf="!reservation.isOnlineReservation">

              <mat-slide-toggle labelPosition="before" [(ngModel)]="reservation.isSelected" (toggleChange)="isOnline()" [ngModelOptions]="{standalone: true}">
                {{reservation.name}}
              </mat-slide-toggle>
              <div *ngIf="!reservation.isOnlineReservation && reservation.isOther && reservation.isSelected" >
                <mat-form-field class="form-group mt-2">
                    <input matInput [(ngModel)]="reservation.otherValue" [formControl]="otherValue"
                    [required]="reservation.isOther"
                    name="other{{index}}">

                </mat-form-field>
                <p class="has-error" *ngIf="otherValue.hasError('required') && isSubmitted">{{ 'forms.Required' | translate }}</p>

              </div>

            </ng-container>
          </div>


        </div>
        <!-- </form> -->
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
      <button mat-button class="btn-grey" (click)="openConfirmDialog()">{{"forms.Cancel" | translate}}</button>
      <!-- *ngIf="isUpdate" -->
      <button mat-raised-button color="primary" [disabled]="loading" [class.loading]="loading"
          (click)="saveRecord()">
          {{"forms.Save" | translate}}
      </button>
  </mat-dialog-actions>
</ng-container>
